import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { User, LogOut, FolderOpen } from 'lucide-react';
import { AuthModal } from './AuthModal';
import { SavedSearches } from '../saved-searches/SavedSearches';
import { useForceLogout } from '../../hooks/useForceLogout';

export function UserMenu() {
  const { user, credits } = useAuth();
  const { handleForceLogout, isLoggingOut } = useForceLogout();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showSavedSearches, setShowSavedSearches] = useState(false);

  if (!user) {
    return (
      <>
        <button 
          onClick={() => setShowAuthModal(true)}
          className="flex items-center gap-2 text-[var(--secondary-text)] hover:text-[var(--primary-text)]"
        >
          <User className="w-5 h-5" />
          Sign In
        </button>
        {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
      </>
    );
  }

  return (
    <>
      <div className="flex items-center gap-4">
        <span className="text-[var(--secondary-text)]">
          Credits: {credits}
        </span>
        <button
          onClick={() => setShowSavedSearches(true)}
          className="flex items-center gap-2 text-[var(--secondary-text)] hover:text-[var(--primary-text)]"
        >
          <FolderOpen className="w-5 h-5" />
          Saved Searches
        </button>
        <button
          onClick={handleForceLogout}
          disabled={isLoggingOut}
          className="flex items-center gap-2 text-[var(--secondary-text)] hover:text-[var(--primary-text)] disabled:opacity-50"
        >
          <LogOut className="w-5 h-5" />
          {isLoggingOut ? 'Signing Out...' : 'Sign Out'}
        </button>
      </div>
      {showSavedSearches && <SavedSearches onClose={() => setShowSavedSearches(false)} />}
    </>
  );
}